import { render, staticRenderFns } from "./TitleDetailJumpLinksV1.vue?vue&type=template&id=5ec2ca71"
import script from "./TitleDetailJumpLinksV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailJumpLinksV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailJumpLinksV1.vue?vue&type=style&index=0&id=5ec2ca71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports